import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PatientHistoryModel} from '../../modules/medical-history/models/patient-history.model';
import {environment} from '../../../environments/environment';
import {ListMedicationHistoryModel} from "../../modules/medical-history/models/medication-history.model";

@Injectable({
  providedIn: 'root'
})
export class MedicalHistoryService {

  constructor(private http: HttpClient) { }

  // getMedicalHistoryByPatient(patientID: string): Observable<any> {
  //   return this.http.get<any>(`api/forms/getMedicalHistoryFormForPatient/${patientID}`);
  // }

  getListMedicalHistory(patientId: string) {
  return this.http.get<ListMedicationHistoryModel[]>(`api/medical-history/get-list-medical-history/${patientId}`);
}

  getListMedicationHistory(patientId: string) {
    return this.http.get<ListMedicationHistoryModel[]>(`api/medical-history/get-list-medication-history/${patientId}`);
  }

  getMedicationHistory(CaseWorkItemFormsId: string) {
    return this.http.get<any>(`api/medical-history/get-medication-history/${CaseWorkItemFormsId}`);
  }

  getMedicalHistory(CaseWorkItemFormsId: string): Observable<any> {
    return this.http.get<any>(`api/medical-history/get-medical-history/${CaseWorkItemFormsId}`);
  }

  GetMedicalRxHistoryByPatient(patientId: string): Observable<any> {
    return this.http.get<any>(`api/medical-history/get-medical-Rx-history/${patientId}`);
  }



  // saveMedicalHistory(model: PatientHistoryModel): Observable<PatientHistoryModel> {
  //   return this.http.post<PatientHistoryModel>('api/medical-history/save-medical-history', model);
  // }
  AddMedication_MedicalForm(patientID: string, isMedicationForm: boolean ) {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    return this.http.get<any>(`api/medical-history/add-medication-medical-form/${patientID}/${isMedicationForm}`);
  }

}
